import { AdminLayout } from "../../components/AdminLayout";

export function AdminReportsPage() {
  return (
    <AdminLayout title="報表預留">
      <section className="action-panel">
        <h2>第一包 Stub</h2>
        <p>報表讀 report_snapshots、finance_daily_summary、finance_monthly_summary；缺資料時顯示需更新，不在頁面載入時全站重爬。</p>
      </section>
    </AdminLayout>
  );
}
